/**
 * Legacy: Marketo Cookie Prefill
 *
 * Automatically updates form info, based on the form info the user filled previously
 *
 * See also:
 * src/assets/js-webpack/legacy/l-get-url-param.js
 *
 * https://developers.marketo.com/javascript-api/forms/api-reference/
 *
 * @module legacy/LMarketoCookiePrefill
 */


// Dependances
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';
import { UCookies } from '../common/utility/u-cookies';


// Vars
// ============================================================================

const targets = [
	{ cookie: 'emailfield',           selector: 'input[name="Email"]' },
	{ cookie: 'fnamefield',           selector: 'input[name="FirstName"]' },
	{ cookie: 'lnamefield',           selector: 'input[name="LastName"]' },
	{ cookie: 'companyfield',         selector: 'input[name="Company"]' },
	{ cookie: 'formAutoFill-Phone',   selector: 'input[name="Phone"]' },
	{ cookie: 'formAutoFill-Title',   selector: 'input[name="Title"]' },    // job title
	// { cookie: 'formAutoFill-Country', selector: 'select[name="Country"]' }, // select, not input
	// { cookie: 'formAutoFill-State',   selector: 'select[name="State"]' },   // only used if Country is USA
];


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	// On submit
	onSubmit_saveCookies();

	// On form load
	onFormLoad_autoFillFormInputs();
	onFormLoad_applyCustomCSS();
}


/**
 * On submit: Save cookies, to store user data
 *
 * @return  {void}
 */
function onSubmit_saveCookies()
{
	$( 'form' ).submit(function( event )
	{
		const $form = $( event.currentTarget );
		const expiryDays = 90;

		targets.forEach( ( target ) =>
		{
			const $input = $form.find( target.selector );

			if ( $input.length )
			{
				UCookies.setCookie( target.cookie, $input.val(), expiryDays );
			}
		});

		return true;
	});
}


/**
 * On form load: Automatically fill in the form, using the user's stored data
 * from cookies
 *
 * @return  {void}
 */
function onFormLoad_autoFillFormInputs()
{
	if ( typeof MktoForms2 !== 'object' )
	{
		return;
	}

	MktoForms2.onFormRender( () =>
	{
		// Prefill inputs with saved user data
		targets.forEach( ( target ) =>
		{
			const cookieVal = UCookies.getCookie( target.cookie );

			if ( cookieVal !== 'undefined' )
			{
				const $input = $( 'form ' + target.selector );

				if ( !$input.val() )
				{
					$input.val( cookieVal );
				}
			}
		});
	});
}


/**
 * On form load: Apply some custom CSS to the form
 *
 * @return  {void}
 */
function onFormLoad_applyCustomCSS()
{
	if ( typeof MktoForms2 !== 'object' )
	{
		return;
	}

	MktoForms2.onFormRender( () =>
	{
		//@TODO: Is all this inline CSS stuff still needed?
		$('form .mktoCheckboxList').parent().find('.mktoLabel.mktoHasWidth').css({
			width: 'calc(100% - 30px)',
			display: 'inline-block'
		});

		$('form .mktoCheckboxList').parent().find('.mktoLogicalField.mktoCheckboxList.mktoHasWidth').css({
			float: 'left',
			marginTop: '3px',
			width: 'auto'
		});

		$('form .mktoCheckboxList').parent().find('.mktoGutter.mktoHasWidth').css({
			display: 'none'
		});

		$('form #Request_Opt_In').parent().find('.mktoLabel.mktoHasWidth').css({
			width: '100%',
			display: 'block'
		});

		$("form label[for=PostalCode]").hide();
	});
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
